module.exports = __webpack_public_path__ + "static/img/4.73a7dd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-salud/4.png
// module id = dykp
// module chunks = 0